<template>
  <div id="app">
    <NotificationCard v-if="get_notification_bar_message != ''"/>
    <Layout v-if="continueLodingApp" />
    <ProgressCard
      v-for="(item, index) in get_import_queue" :key="`import-${item.progressId}`"
      :text="item.fileName"
      :iconName="item.iconName"
      :templateType="get_import_queue.templateType"
      :position="get_import_queue.length - index"
      :progressId="item.progressId"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Layout from '@/components/global/layout';
import ProgressCard from '@/components/global/progressCard';
import NotificationCard from '@/components/global/notification';

import axios from 'axios';

export default {
  components: {
    Layout, ProgressCard, NotificationCard,
  },
  data() {
    return {
      continueLodingApp: false,
    };
  },
  computed: {
    ...mapGetters([
      'get_notification_bar_message',
      'get_import_queue',
      'get_user'
    ]),
  },
  watch: {
    '$store.state.forceRedirect'(path) {
      if (path) {
        this.$store.commit('SET_FORCE_REDIRECT', null)
        this.$router.push(path).catch(() => {})
      }
    },
    'get_user' : function(user) {
      if (user && user.admin_custom_style) {
        const head = document.head || document.getElementsByTagName('head')[0]
        const style = document.createElement('style')

        head.appendChild(style);
        style.appendChild(document.createTextNode(user.admin_custom_style));
      }
    }
  },
  created() {
    // console.log('MODE: ', process.env.VUE_APP_MODE)
    if (localStorage.getItem('token') !== null) {
      // Make test call to check token quality
      axios.defaults.headers.common = {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      };
      this.$store.dispatch('TEST_TOKEN').then((res) => {
        if(res === 200){
          // TOKEN IS GOOD
          this.$store.dispatch('LOGIN_USER_FLAG', true);
          this.continueLodingApp = true;

          if ((!this.get_import_queue.length || this.get_import_queue.length <= 0) && localStorage.getItem('importQueue')) {
            let importQueue = JSON.parse(localStorage.getItem('importQueue'));
            importQueue.forEach(queueItem => {
              if (queueItem.progressStatus < 100) {
                this.$store.dispatch('STORE_IN_QUEUE', queueItem)
              }
            })
          }
        } else {
          // TOKEN IS BAD
          localStorage.removeItem('token');
          //this.$router.push('/login')
          this.$store.dispatch('LOGIN_USER_FLAG', false);
          this.continueLodingApp = true;
        }
      });
    } else {
      //this.$router.push('/login')
      this.$store.dispatch('LOGIN_USER_FLAG', false);
      this.continueLodingApp = true;
    }
  },
}
</script>

<style lang="scss">
  @import "./assets/scss/main.scss";
</style>
